// Minimal HTML escaper — safe for interpolating user-supplied text into the
// resume preview iframe. Handles the 5 chars that matter for resume content.
export const escapeHtml = (str) => {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};
